<!-- Card -->
<section class="card">
  <!-- Header -->
  <div class="card-header">
    <h3 class="card-title">
      <i role="img" class="fa fa-credit-card" aria-hidden="true"></i>
      {{ 'paymentModule.payments' | translate }}
    </h3>

    <button
      *ngIf="!readonly && canCreatePayment && !isSaleCancelled"
      class="btn btn-primary btn-sm"
      (click)="onClickCreatePayment()"
      [canSee]="[accessRights.Sales_write]"
      data-test-id="create-payment-button"
    >
      {{ 'general.create' | translate }}
    </button>
  </div>
  <!-- End Header -->

  <!-- Body -->
  <div class="card-body">
    <payment-table
      (onClickRow)="onRowClicked($event)"
      [tableData]="payments$ | async"
      (onBulkAction)="onBulkAction($event)"
      [isVertical]="true"
      [readonly]="readonly"
      [sale]="sale$ | async"
    ></payment-table>

    <button
      type="button"
      class="btn btn-sm btn-soft-primary"
      *ngIf="canSetToPayInFrontend$ | async"
      (click)="payInConsumerFrontend()"
    >
      {{ 'saleModule.payInCF' | translate }}
    </button>
  </div>
</section>
<!-- End Body -->
<!-- End Card -->
